export default import.meta.ROLLDOWN_FILE_URL_6NAGU4yxZv4gqo8aTZNSKg